(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flowever-delivery-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-flowever-delivery]');
    if (!root) return;

    const choices = [...root.querySelectorAll('input[name="flowever_fulfillment"]')];
    const singleFields = root.querySelector('[data-single-delivery-fields]');
    const multiFields = root.querySelector('[data-multi-delivery-fields]');
    const multiToggle = root.querySelector('[data-multi-toggle]');
    const multiAddress = root.querySelector('[data-multi-address]');
    const requestedAt = root.querySelector('#flowever-requested-at');
    const sharedDate = root.querySelector('[data-shared-date]');
    const error = root.querySelector('[data-delivery-error]');
    const singleRequiredInputs = [...root.querySelectorAll('[data-delivery-required]')];
    const multiRequiredInputs = [...root.querySelectorAll('[data-multi-required]')];
    const singleAttributeInputs = [...root.querySelectorAll('[data-attribute]:not([data-multi-attribute])')];
    const multiAttributeInputs = [...root.querySelectorAll('[data-multi-attribute]')];
    const existingBouquetAttributes = [...root.querySelectorAll('[data-existing-bouquet-attribute]')];
    const singlePostcode = root.querySelector('[data-postcode]');
    const multiPostcodes = [...root.querySelectorAll('[data-multi-postcode]')];
    const multiDates = [...root.querySelectorAll('[data-multi-date]')];
    const surchargeBox = root.querySelector('[data-courier-surcharge]');
    const bouquetCount = Number(surchargeBox?.dataset.bouquetCount || 0);
    const surchargeVariantId = surchargeBox?.dataset.surchargeVariantId || '';
    const surchargeLineKey = surchargeBox?.dataset.surchargeLineKey || '';
    const idfPostcode = /^(75|77|78|91|92|93|94|95)\d{3}$/;
    let processing = false;

    const localDateTime = (date) => {
      const offset = date.getTimezoneOffset() * 60000;
      return new Date(date.getTime() - offset).toISOString().slice(0, 16);
    };

    const setMinimumDate = () => {
      const minimum = new Date(Date.now() + (48 * 60 * 60 * 1000));
      minimum.setMinutes(Math.ceil(minimum.getMinutes() / 15) * 15, 0, 0);
      [requestedAt, ...multiDates].forEach((input) => {
        input.min = localDateTime(minimum);
        if (input.value && new Date(input.value).getTime() < minimum.getTime()) input.value = '';
      });
    };

    const selectedMode = () => choices.find((choice) => choice.checked)?.value || '';

    const setFieldsetState = (fieldset, inputs, active) => {
      if (!fieldset) return;
      fieldset.hidden = !active;
      inputs.forEach((input) => {
        input.disabled = !active;
      });
    };

    const updateFields = () => {
      const isDelivery = selectedMode() === 'Livraison';
      const isMulti = isDelivery && Boolean(multiAddress?.checked);
      if (multiToggle) multiToggle.hidden = !isDelivery;
      sharedDate.hidden = isMulti;
      requestedAt.disabled = isMulti;
      requestedAt.required = !isMulti;
      setFieldsetState(singleFields, singleAttributeInputs, isDelivery && !isMulti);
      setFieldsetState(multiFields, multiAttributeInputs, isMulti);
      if (surchargeBox) surchargeBox.hidden = !isDelivery || isMulti || bouquetCount < 2;
      singleRequiredInputs.forEach((input) => { input.required = isDelivery && !isMulti; });
      multiRequiredInputs.forEach((input) => { input.required = isMulti; });
      error.hidden = true;
    };

    const showError = (message, field) => {
      error.textContent = message;
      error.hidden = false;
      field?.focus();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const validate = () => {
      const mode = selectedMode();
      if (!mode) {
        showError('Choisissez la livraison ou le retrait à Igny.', choices[0]);
        return false;
      }
      const isMulti = mode === 'Livraison' && Boolean(multiAddress?.checked);
      const activeDates = isMulti ? multiDates : [requestedAt];
      const missingDate = activeDates.find((input) => !input.value);
      if (missingDate) {
        showError(isMulti ? 'Choisissez une date et une heure pour chaque bouquet.' : 'Choisissez une date et une heure.', missingDate);
        return false;
      }
      const invalidDate = activeDates.find((input) => new Date(input.value).getTime() < Date.now() + (48 * 60 * 60 * 1000));
      if (invalidDate) {
        showError('Chaque créneau doit être situé au moins 48 heures après la commande.', invalidDate);
        return false;
      }
      if (mode === 'Livraison') {
        const activeRequiredInputs = isMulti ? multiRequiredInputs : singleRequiredInputs;
        const activePostcodes = isMulti ? multiPostcodes : [singlePostcode];
        const missing = activeRequiredInputs.find((input) => !input.value.trim());
        if (missing) {
          showError(isMulti ? 'Renseignez toutes les coordonnées obligatoires pour chaque bouquet.' : 'Renseignez toutes les coordonnées obligatoires du destinataire.', missing);
          return false;
        }
        const invalidPostcode = activePostcodes.find((input) => !idfPostcode.test(input.value.trim()));
        if (invalidPostcode) {
          showError('Toutes les adresses de livraison doivent être situées en Île-de-France.', invalidPostcode);
          return false;
        }
      }
      error.hidden = true;
      return true;
    };

    const saveAndCheckout = async () => {
      if (processing || !validate()) return;
      processing = true;
      root.setAttribute('aria-busy', 'true');
      const mode = selectedMode();
      const isMulti = mode === 'Livraison' && Boolean(multiAddress?.checked);
      const surchargeQuantity = mode === 'Livraison' && !isMulti ? Math.max(0, bouquetCount - 1) : 0;
      const attributes = {
        'Mode de remise': mode,
        'Date et heure souhaitées': isMulti ? 'Plusieurs créneaux' : requestedAt.value,
        'Livraison multi-adresses': isMulti ? 'Oui' : 'Non',
        'Supplément coursier': surchargeQuantity > 0 ? `${surchargeQuantity} × 3 €` : 'Aucun'
      };
      existingBouquetAttributes.forEach((element) => {
        attributes[element.dataset.existingBouquetAttribute] = '';
      });
      singleAttributeInputs.forEach((input) => {
        attributes[input.dataset.attribute] = mode === 'Livraison' && !isMulti ? input.value.trim() : '';
      });
      multiAttributeInputs.forEach((input) => {
        attributes[input.dataset.attribute] = isMulti ? input.value.trim() : '';
      });
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        if (surchargeQuantity > 0 && !surchargeLineKey) {
          const addResponse = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: surchargeVariantId,
                quantity: surchargeQuantity,
                properties: { '_flowever_surcharge': 'true' }
              }]
            })
          });
          if (!addResponse.ok) throw new Error('surcharge add failed');
        }

        const updates = {};
        if (surchargeLineKey) updates[surchargeLineKey] = surchargeQuantity;
        const response = await fetch(`${shopRoot}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes, updates })
        });
        if (!response.ok) throw new Error('cart update failed');
        window.location.assign(`${shopRoot}checkout`);
      } catch (fetchError) {
        processing = false;
        root.removeAttribute('aria-busy');
        showError('Impossible d’enregistrer les informations. Réessayez dans quelques instants.');
      }
    };

    choices.forEach((choice) => choice.addEventListener('change', updateFields));
    multiAddress?.addEventListener('change', updateFields);
    setMinimumDate();
    updateFields();

    document.addEventListener('click', (event) => {
      const checkoutButton = event.target.closest('[name="checkout"]');
      if (!checkoutButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      saveAndCheckout();
    }, true);

    document.addEventListener('submit', (event) => {
      if (event.submitter?.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      saveAndCheckout();
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flowever-journal-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initJournal(root) {
      if (!root || root.dataset.journalReady === 'true') return;
      root.dataset.journalReady = 'true';

      var home = document.querySelector('.fv');
      var workshops = home && home.querySelector('.fv__workshops');
      if (home && workshops && root.parentElement !== home) {
        workshops.insertAdjacentElement('afterend', root);
      }

      var track = root.querySelector('[data-journal-track]');
      if (!track) return;

      function scroll(direction) {
        var card = track.querySelector('.fjh__card');
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16);
        var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * .85;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      var prev = root.querySelector('[data-journal-prev]');
      var next = root.querySelector('[data-journal-next]');
      if (prev) prev.addEventListener('click', function () { scroll(-1); });
      if (next) next.addEventListener('click', function () { scroll(1); });
    }

    function boot() {
      document.querySelectorAll('[data-flowever-journal]').forEach(initJournal);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flowever-premium-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fv-faq-accordion]').forEach(function (list) {
    var items = Array.from(list.querySelectorAll(':scope > details'));
    items.forEach(function (item) {
      item.removeAttribute('open');
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  });

  function syncFloweverPersonalNote(form) {
    var toggle = form.querySelector('[data-note-toggle]');
    var field = form.querySelector('[data-note-field]');
    var message = form.querySelector('[data-note-message]');
    var copy = form.querySelector('[data-note-copy]');
    if (!toggle || !field || !message) return;
    var enabled = toggle.checked;
    field.hidden = !enabled;
    message.disabled = !enabled;
    message.required = enabled;
    form.querySelectorAll('[data-note-extra], [data-note-copy]').forEach(function (input) {
      input.disabled = !enabled;
    });
    if (copy) copy.value = enabled ? message.value.trim() : '';
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-note-toggle]')) {
      syncFloweverPersonalNote(event.target.closest('form'));
      return;
    }
    if (!event.target.matches('[data-variant-select]')) return;

    var card = event.target.closest('[data-product-card]');
    var option = event.target.options[event.target.selectedIndex];
    var price = card.querySelector('[data-variant-price]');

    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-note-message]')) return;
    var form = event.target.closest('form');
    var copy = form && form.querySelector('[data-note-copy]');
    if (copy) copy.value = event.target.value.trim();
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('.fv__buy');
    if (!form) return;

    event.preventDefault();

    syncFloweverPersonalNote(form);
    if (!form.reportValidity()) return;

    var root = form.closest('.fv');
    var card = form.closest('[data-product-card]');
    var button = form.querySelector('button[type="submit"]');
    var status = root.querySelector('[data-cart-status]');
    var originalButton = button.innerHTML;

    button.disabled = true;

    try {
      var requestHeaders = { Accept: 'application/json' };
      var requestBody = new FormData(form);
      var noteToggle = form.querySelector('[data-note-toggle]');
      var noteMessage = form.querySelector('[data-note-message]');
      if (noteToggle && noteToggle.checked && noteMessage) {
        var selectedVariant = form.querySelector('[name="id"]');
        var personalMessage = noteMessage.value.trim();
        requestHeaders['Content-Type'] = 'application/json';
        requestBody = JSON.stringify({
          items: [
            { id: selectedVariant.value, quantity: 1, properties: { 'Mot personnalisé': personalMessage } },
            { id: '53609637773648', quantity: 1, properties: { '_Bouquet': card.dataset.productTitle, '_Mot personnalisé': personalMessage } }
          ]
        });
      }
      var response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: requestHeaders,
        body: requestBody
      });

      if (!response.ok) throw new Error('cart');

      var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      var cart = await cartResponse.json();

      document.querySelectorAll('[data-cart-count]').forEach(function (count) {
        count.textContent = '(' + cart.item_count + ')';
      });

      button.textContent = root.dataset.addedLabel;
      status.textContent = card.dataset.productTitle + ' ' + root.dataset.addedStatus;
      status.classList.add('is-visible');
      window.clearTimeout(status.hideTimer);
      status.hideTimer = window.setTimeout(function () {
        status.classList.remove('is-visible');
      }, 3200);
      if (noteToggle) {
        noteToggle.checked = false;
        if (noteMessage) noteMessage.value = '';
        syncFloweverPersonalNote(form);
      }
    } catch (error) {
      HTMLFormElement.prototype.submit.call(form);
      return;
    } finally {
      window.setTimeout(function () {
        button.disabled = false;
        button.innerHTML = originalButton;
      }, 1400);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flowever-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fvp').forEach(function (root) {
    var form = root.querySelector('.fvp__form');
    var price = root.querySelector('[data-fvp-price]');
    var mainImage = root.querySelector('.fvp__main-image');
    var localStatus = root.querySelector('[data-fvp-status]');
    var toast = root.querySelector('[data-fvp-cart-status]');

    root.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (price) price.textContent = input.dataset.price;
        if (mainImage && input.dataset.imageSrc) {
          mainImage.src = input.dataset.imageSrc;
          mainImage.removeAttribute('srcset');
          if (input.dataset.imageAlt) mainImage.alt = input.dataset.imageAlt;
        }
      });
    });

    root.querySelectorAll('[data-fvp-thumb]').forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = thumbnail.dataset.imageSrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;
        root.querySelectorAll('[data-fvp-thumb]').forEach(function (item) {
          item.classList.remove('is-active');
          item.removeAttribute('aria-current');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-current', 'true');
      });
    });

    if (!form) return;

    function syncPersonalNote() {
      var toggle = form.querySelector('[data-note-toggle]');
      var field = form.querySelector('[data-note-field]');
      var message = form.querySelector('[data-note-message]');
      var copy = form.querySelector('[data-note-copy]');
      if (!toggle || !field || !message) return;
      var enabled = toggle.checked;
      field.hidden = !enabled;
      message.disabled = !enabled;
      message.required = enabled;
      form.querySelectorAll('[data-note-extra], [data-note-copy]').forEach(function (input) {
        input.disabled = !enabled;
      });
      if (copy) copy.value = enabled ? message.value.trim() : '';
    }

    var noteToggle = form.querySelector('[data-note-toggle]');
    var noteMessage = form.querySelector('[data-note-message]');
    if (noteToggle) noteToggle.addEventListener('change', syncPersonalNote);
    if (noteMessage) noteMessage.addEventListener('input', function () {
      var copy = form.querySelector('[data-note-copy]');
      if (copy) copy.value = noteMessage.value.trim();
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      syncPersonalNote();
      if (!form.reportValidity()) return;
      var button = form.querySelector('.fvp__add');
      if (!button || button.disabled) return;
      var originalLabel = button.textContent;
      button.disabled = true;

      try {
        var requestHeaders = { Accept: 'application/json' };
        var requestBody = new FormData(form);
        if (noteToggle && noteToggle.checked && noteMessage) {
          var selectedVariant = form.querySelector('input[name="id"]:checked');
          var personalMessage = noteMessage.value.trim();
          requestHeaders['Content-Type'] = 'application/json';
          requestBody = JSON.stringify({
            items: [
              { id: selectedVariant.value, quantity: 1, properties: { 'Mot personnalisé': personalMessage } },
              { id: '53609637773648', quantity: 1, properties: { '_Bouquet': root.dataset.productTitle, '_Mot personnalisé': personalMessage } }
            ]
          });
        }
        var response = await fetch(root.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: requestHeaders,
          body: requestBody
        });
        if (!response.ok) throw new Error('cart');

        var cartResponse = await fetch(root.dataset.cartUrl + '.js', {
          headers: { Accept: 'application/json' }
        });
        var cart = await cartResponse.json();

        document.querySelectorAll('[data-cart-count]').forEach(function (count) {
          count.textContent = '(' + cart.item_count + ')';
        });

        button.textContent = root.dataset.addedLabel;
        if (localStatus) localStatus.textContent = root.dataset.productTitle + ' a bien été ajouté au panier.';
        if (toast) {
          toast.textContent = root.dataset.productTitle + ' a bien été ajouté au panier.';
          toast.classList.add('is-visible');
          window.clearTimeout(toast.hideTimer);
          toast.hideTimer = window.setTimeout(function () {
            toast.classList.remove('is-visible');
          }, 3200);
        }
        if (noteToggle) {
          noteToggle.checked = false;
          if (noteMessage) noteMessage.value = '';
          syncPersonalNote();
        }
      } catch (error) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      } finally {
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalLabel;
        }, 1400);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
